export type MenuItemType = {
  name: string
  label: string
  icon?: any
  tracking: string
  [x: string]: any
}

export type MenuItemWithSubItemsType = {
  name: string
  label: string
  tracking: string
  icon: any
  subItems?: {
    name: string
    label: string
    icon: any
    [x: string]: any
  }[]
  [x: string]: any
}

export type MenuConfigType = MenuItemType | MenuItemWithSubItemsType

export const MENU_ITEMS: MenuConfigType[] = [
  {
    name: 'dashboard',
    label: 'navigation.entry.dashboard',
    tracking: 'preview'
  },
  {
    name: 'myBookings',
    label: 'navigation.entry.reservation',
    tracking: 'your reservation'
  },
  {
    name: 'myLoyaltyProgram',
    label: 'navigation.entry.fidelity',
    tracking: 'your loyalty account'
  },
  {
    name: 'globalTransactionHistory',
    label: 'navigation.entry.transactions',
    tracking: 'your account activity'
  },
  {
    name: 'myPartners',
    label: 'partners.header.title',
    tracking: 'your partners' //TODO user story tracking
  },
  {
    name: 'my-information',
    label: 'navigation.entry.data.all',
    tracking: 'your information',
    path: '/my-information'
  },
  {
    name: 'preferences',
    label: 'preferencePage.title',
    path: '/preferences',
    tracking: 'stay preferences'
  },
  {
    id: 'Newsletter',
    name: 'newsletter',
    label: 'navigation.entry.communication',
    tracking: 'your preferences'
  },
  {
    id: 'securitySettings',
    name: 'security-settings',
    label: 'navigation.entry.securitySettings',
    tracking: 'security settings'
  }
]

export const SUB_LEVELS_ROUTES: Record<string, string[]> = {}
